import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Grid } from 'formlabs-web-components/Grid';
import { Button } from 'formlabs-web-components/Link';
import Ambassador from './Ambassador';
import './ambassadors.module.css';

const Ambassadors = ({
  classes,
  styleNames,
  styles,
  ambassadors,
  page,
  hasNext,
  hasPrev
}) => {
  const { t } = useTranslation();

  const prev = parseInt(page, 12) - 1;
  const next = parseInt(page, 12) + 1;

  return (
    <div className={classes} styleName={classNames(styleNames)} style={styles}>
      <Grid direction="x" gutters="padding">
        {ambassadors.map(ambassador => (
          <Ambassador key={ambassador.name} {...ambassador} />
        ))}
      </Grid>
      <div styleName="pagination-wrapper">
        {hasPrev && (
          <Button
            color="light"
            rel="prev"
            url={prev > 0 ? `?page=${prev}` : null}
          >
            <i className="fl-arrow-left" /> {t('Previous')}
          </Button>
        )}
        {hasNext && (
          <Button
            styleName="pagination-button"
            color="light"
            rel="next"
            url={`?page=${next}`}
          >
            {t('Next')} <i className="fl-arrow-right" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default Ambassadors;
